import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import PageBackbutton from './PageBackbutton';
import Message from 'components/Message';
import { isMobileOnly } from 'react-device-detect';

const PageTitle = ({
    children,
    title, url,
    className,
    mobileMessageTarget
}) => {
    const __className = cx('page__title', {
        [className]: className,
    });
    return (
        <React.Fragment>
            <div className={__className}>
                {title ? (
                    title
                ) : (
                        <PageBackbutton url={url}>
                            <span>{children}</span>
                        </PageBackbutton>
                    )}
            </div>
            {isMobileOnly && <Message position={mobileMessageTarget || 'top'} />}
        </React.Fragment>
    );
};

PageTitle.propTypes = {
    children: PropTypes.any,
    title: PropTypes.any,
    url: PropTypes.any,
    className: PropTypes.string,
    mobileMessageTarget: PropTypes.string,
};

export default PageTitle;
